import { addMessage, receiveMessage, fetchMessages } from '../Redux/slice/chatSlice';

const messageMiddleware = store => next => action => {
    if (action.type === addMessage.type || action.type === receiveMessage.type) {
        const { receiverId, senderId } = action.payload.data || action.payload;
        const state = store.getState();
        const userId = state.userData?.userData?.user?._id;
        let chatIndex;

        if (action.type === addMessage.type) {
            chatIndex = state.chat.messages.findIndex(chat => chat.id === receiverId || chat.id === senderId);
        } else {
            chatIndex = state.chat.messages.findIndex(chat => chat.id === senderId);
        }

        if (chatIndex === -1) {
            store.dispatch(fetchMessages({ userId, page:1, limit: 10 }));
        }
    }

    return next(action);
};

export default messageMiddleware;
